module.exports = __webpack_public_path__ + "img/campaigns.ad2880d2.gif";